

export const SingleSolutionCard = ({ imageSrc, title, description }) => {
  return (
    <div className="rounded-3xl flex-col">
      <div className="w-full flex-1 flex items-center justify-center mb-8">
        <img src={imageSrc} alt="Solution Illustration" className="w-full h-auto rounded-2xl object-contain" />
      </div>
      <h3 className="text-[#232323] text-[1.1rem] font-bold mb-2">{title}</h3>
      <p className="text-[#6F6F6F] text-[1rem] medium leading-snug">{description}</p>
    </div>
  );
};